var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2344 13.7499V13.7829M8.36019 7.69163C8.36019 6.63655 9.19966 5.78123 10.2352 5.78123C11.2707 5.78123 12.1102 6.63655 12.1102 7.69163C12.1102 8.74672 11.2707 9.60203 10.2352 9.60203C10.2352 9.60203 10.2344 10.1722 10.2344 10.8756M17.7344 5.31248L17.7344 14.6875C17.7344 16.2408 16.4752 17.5 14.9219 17.5H5.54688C3.99357 17.5 2.73438 16.2408 2.73438 14.6875V5.31248C2.73438 3.75919 3.99357 2.5 5.54688 2.5H14.9219C16.4752 2.5 17.7344 3.75919 17.7344 5.31248Z",
    stroke: "#6F6F6F",
    strokeWidth: 1.67381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/HelpIcon.d39b7b698c32301344819b92eccc3b0c.svg";
export { ForwardRef as ReactComponent };